import angular from 'angular';
import { isString, startCase } from 'lodash';

module.exports = angular.module('common.filters.shortName', [])
.filter('shortName', function() {
  return function(input) {
    if (!isString(input)) return input;
    let parts = input.trim().split(' ');
    if (parts.length > 1) {
      return startCase(`${parts[0]} ${parts[parts.length - 1][0]}`);
    }
    return startCase(parts[0]);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/short-name.js
 **/